import React, { useEffect, useState } from 'react';
import { Text } from 'shared-components';
import { BCMShortWizardShell } from './BCMShortWizardShell';
import { TentoZ } from './TentoZ';

// Full-page submitting state rendered during the BCM-Short API submit.
// Shows a spinning Tento "Z" and "SUBMITTING YOUR APPLICATION ..." with
// animated dots — matches Volt's SubmittingStep.
export const BCMShortSubmittingOverlay: React.FC<{ label?: string; currentStepIndex?: number }> = ({
  label = 'SUBMITTING YOUR APPLICATION',
  currentStepIndex = 1,
}) => {
  const [dots, setDots] = useState('');

  useEffect(() => {
    const interval = setInterval(() => {
      setDots((prev) => (prev.length < 3 ? prev + '.' : ''));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <BCMShortWizardShell currentStepIndex={currentStepIndex} isSubmitting>
      <div className="flex flex-col gap-[20px] items-center justify-center w-full h-full">
        <div className="h-[59px] w-[60px]">
          <TentoZ className="animate-spin2x" />
        </div>
        <div className="flex gap-[10px] items-center justify-center py-[20px] w-full">
          <Text variant="headline-sm" className="!font-extended !uppercase !text-[16px] !leading-none text-center">
            {label}
            <span className="inline-block min-w-[12px] text-left">{dots}</span>
          </Text>
        </div>
      </div>
    </BCMShortWizardShell>
  );
};
